/** Rótulo físico do conector. Riseon DC rotula as tomadas como A e B, e o app
 * mostrando "1 e 2" confundia (feedback cliente 2026-07-02 nº 9). A escolha é
 * por ponto, via capability `connector_letters` (dado, não código — §3.6):
 * toggle no admin, efeito imediato, sem deploy. */
export function hasConnectorLetters(
  capabilities: Record<string, unknown> | null | undefined
): boolean {
  return capabilities?.['connector_letters'] === true;
}

/** 1 → "A", 2 → "B" quando `letterLabel`; senão o próprio número. */
export function connectorLabel(connectorNumber: number, letterLabel: boolean): string {
  return letterLabel ? String.fromCharCode(64 + connectorNumber) : String(connectorNumber);
}
